import "./index.css";
import { useAuth } from "../auth/AuthContext";
import GuestHomePageComponent from "../components/home/GuestHomePageComponent";
import LoggedInHomePageComponent from "../components/home/LoggedInHomePageComponent";
import { Box, CircularProgress } from "@mui/material";

const HomePage = () => {
  const { isAuthenticated, isLoading } = useAuth();
  
  // Show loading spinner while auth is initializing
  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "80vh", pt: { xs: 7, sm: 9 } }}>
        <CircularProgress />
      </Box>
    );
  }

  // Keep page-level spacing only; child components render their own complete layouts.
  if (!isAuthenticated) {
    return (
      <Box sx={{ pt: { xs: 7, sm: 9 }, pb: 6, minHeight: "calc(100vh - 72px)" }}>
        <GuestHomePageComponent />
      </Box>
    );
  }

  return (
    <Box sx={{ pt: { xs: 7, sm: 9 }, pb: 6, minHeight: "calc(100vh - 72px)" }}>
      <LoggedInHomePageComponent />
    </Box>
  );
};

export default HomePage;